import { render } from "./FirstName.vue?vue&type=template&id=76c3b8a8"
import script from "./FirstName.vue?vue&type=script&lang=js"
export * from "./FirstName.vue?vue&type=script&lang=js"
script.render = render

export default script